<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de vendas
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-indicadores-marketplace-lista-vendas
          :vendas="vendas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import IndicadoresMarketplace from './indicadores-marketplace';
import IndicadoresMarketplaceListaVendas from './IndicadoresMarketplaceListaVendas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      vendas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.dataMes.initialDate} and dataCompra <= ${this.dataMes.finalDate} and situacao in ("ENVIADA", "APROVADA", "SOLICITADO_REVISAO")`;
    },
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getVendas();
    },
    onClickRefresh() {
      this.getVendas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getVendas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return IndicadoresMarketplace.getVendas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.vendas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dataMes(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.resetPage();
      this.onClickRefresh();
    },
  },
  components: {
    pxIndicadoresMarketplaceListaVendas: IndicadoresMarketplaceListaVendas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
